/*
 * Copyright (c) 2024 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 3/12/2024
 */

import { apiSlice } from "../Slices/apiSlice";

export const NotificationService = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getAllNotifications: builder.query({
            query: () => "/email-management/get-all-notifications",
            providesTags: ["notification"],
        }),

        getNotificationById: builder.query({
            query: (id) => `/email-management/get-notification/${id}`,
            providesTags: ["notification"],
        }),

        updateNotification: builder.mutation({
            query: (Details) => ({
                url: `/email-management/update_notification`,
                method: 'PUT',
                body: Details
            }),
            invalidatesTags: ["notification"],
        }),

    })
});

export const {
    useGetAllNotificationsQuery,
    useGetNotificationByIdQuery,
    useUpdateNotificationMutation,
} = NotificationService;